import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

import * as _ from 'underscore';
import { PagedPayload } from '../../../models/paged-payload';
import { UserManagementService } from '../../../services/user-management.service';
import { ClientUser } from '../../../models/client-user-management';
import { InstanceTypes } from '../../../models/instance-types';

@Component({
  selector: 'app-client-user-search',
  templateUrl: './client-user-search.component.html',
  styleUrls: ['./client-user-search.component.css'],
  standalone: false
})
export class ClientUserSearchComponent implements OnInit {
  @Input()
  public currentUsers: ClientUser[] = [];
  @Output()
  public userChosen = new EventEmitter<ClientUser>();
  public searchQuery: string | null = null;
  public hasSearched: boolean = false;
  public items: any[] = [];
  public minSearchLength = 3;
  public showSearchResults: boolean = false;
  public maxResultSet = 5;

  constructor(
    private userService: UserManagementService,
    @Inject('env') private env: any
  ) {
    this.search = _.debounce(this.search, 250);
  }
  public get isClientPortal() {
    return this.env.instanceType === InstanceTypes.ClientPortal;
  }
  ngOnInit(): void {}
  chosen(item: any) {
    const admin = 'Client Portal Admin';
    const user = 'Client Portal User';
    let initialAccessLevel = this.isClientPortal ? user : admin;
    //for some reason this API call is returning in camelCase instead
    //of PascalCase, which every other component expect. Translating it here.
    const result: ClientUser = {
      UserId: item.userId,
      FirstName: item.firstName,
      LastName: item.lastName,
      UserName: item.userName,
      IsLocked: false,
      CanBeUnlockedByNonCsr: null,
      Roles: [],
      RegistrationStatus: '',
      Permissions: [],
      TimekeepingId: null
    };
    this.userChosen.emit(result);
    this.showSearchResults = false;
    this.searchQuery = null;
  }
  search() {
    if (this.searchQuery.length >= this.minSearchLength) {
      this.userService
        .searchUsers({
          omniSearch: this.searchQuery,
          page: 1,
          pageSize: this.maxResultSet,
          name: null,
          email: null,
          phone: null
        })
        .subscribe(data => this._searchCallback(data));
    }
  }

  showResults() {
    if (this.searchQuery && this.searchQuery.length >= this.minSearchLength) {
      this.showSearchResults = true;
    } else if (this.showSearchResults) {
      setTimeout(() => (this.showSearchResults = false), 250);
    }
  }

  private _searchCallback(data: PagedPayload<ClientUser> | any) {
    this.showResults();
    this.hasSearched = true;
    if (data && data.Items) {
      this.items = data.Items.filter(x => this.currentUsers.every(y => y.UserId != x.userId));
    } else {
      this.items = [];
    }
  }
}
